import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";


export default class LanguageService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }


    async GetLanguageOverview(){
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/language/overview",
        {
            headers: {
                "Authorization": "bearer " + Cookies.get("access_token")
            },
            method: "GET"
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

}